import qs from 'qs';
import { getApiGalaxyServer } from 'services';

export interface SuppressedEmail {
  emailAddress: string;
  reason: string;
  lastUpdateTime: string;
}

export interface ListSuppressedEmailsParams {
  domain: string[];
}

// Override default `arrayFormat: "brackets"` so the request is `?domain=a&domain=b`
// rather than `?domain[]=a&domain[]=b`, matching the galaxy-server contract.
const repeatArraySerializer = (params: Record<string, unknown>) =>
  qs.stringify(params, { arrayFormat: 'repeat' });

export const listSuppressedEmailsApi = ({
  params,
  token,
  config,
}: BaseApiParams<ListSuppressedEmailsParams>) =>
  getApiGalaxyServer<SuppressedEmail[]>(
    '/aws/listSuppressedEmails',
    {
      ...config,
      params: { domain: params.domain },
      paramsSerializer: repeatArraySerializer,
    },
    token,
  );
